import { Injectable } from "@angular/core";
import { CoreLogService } from "./log.service";
import { SystemComponent } from "./system/systemComponent";
import * as _ from "lodash";

/** Angular und Workflowspezifische Funktionen */
@Injectable()
export class CoreSystemService {

    private _component: SystemComponent;

    constructor(private _coreLogService: CoreLogService) {
        this.setComponent(new SystemComponent(this._coreLogService));
    }

    /** Komponentenfunktionen */
    public get component(): SystemComponent {
        return this._component;
    }

    private setComponent(value: SystemComponent) {
        this._component = value;
    }
}
